export default __webpack_public_path__ + "static/media/center.55276ff9.svg";